import { t } from '@lingui/macro';
import { Tag, TagProps } from '@luminovo/design-system';

export const MissingTag = ({ color }: { color: TagProps['color'] }): JSX.Element => {
    return <Tag color={color} label={t`Missing`} attention="low" />;
};
